export const FileManagementModalStep = {
  IMAGE_SELECT: 'IMAGE_SELECT',
  FILE_UPLOAD: 'FILE_UPLOAD',
  LOCAL_IMAGE_UPLOAD: 'LOCAL_IMAGE_UPLOAD',
  STOCK_IMAGE_SEARCH: 'STOCK_IMAGE_SEARCH',
};
